import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331941a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base_radio" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "base_radio_text" }
const _hoisted_4 = { class: "base_radio_text_main" }
const _hoisted_5 = { class: "base_radio_text_sub" }

import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseRadioButton',
  props: {
  name: {
    type: String as PropType<HTMLInputElement['name']>,
    default: '',
  },
  value: {
    type: null,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  subLabel: {
    type: String,
    default: '',
  },
  modelValue: {
    type: null,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "base_radio_input",
      type: "radio",
      name: props.name,
      value: props.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null))
    }, null, 8, _hoisted_2), [
      [_vModelRadio, _unref(selectedValue)]
    ]),
    _createElementVNode("span", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.label), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(props.subLabel), 1)
    ])
  ]))
}
}

})